<template>
    <Navbar />
    <Home />
    <About />
    <!-- <Skills /> -->
    <Services />
    <Portfolio />
    <Contact />
    <Footer />
</template>

<script>
import Home from '@/components/mainComponents/Home.vue'
import Skills from '@/components/mainComponents/Skills.vue'
import Navbar from '@/components/mainComponents/Navbar.vue'
import About from '@/components/mainComponents/About.vue'
import Services from "@/components/mainComponents/Services.vue"
import Portfolio from "@/components/mainComponents/Portfolio.vue"
import Contact from '@/components/mainComponents/Contact.vue'
import Footer from '@/components/mainComponents/Footer.vue'



export default {
  name: 'HomeView',
  components: {
    Home,
    Skills,
    Navbar,
    About,
    Services,
    Portfolio,
    Contact,
    Footer,
  },
}
</script>

<style lang="scss">
.bg-text {
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 700;
    min-width: 80%;
    font-size: 400px;
    text-align: center;
    text-transform: uppercase;
    color: #f6f6f6;
    opacity: 75%;
    @media(max-width: 1024px) {
      font-size: 240px;
    }
    @media(max-width: 768px) {
      font-size: 200px;
      // min-width: 120%;
      // width: 100%;
    }
     @media(max-width: 425px) {
      font-size: 100px;
      // min-width: 120%;
      // width: 100%;
    }
}

.title-container {
        text-align: center;
        padding-bottom: 1.5rem;
         @media(max-width:350px) {
              padding-bottom: 1rem;
            }
        .title {
            font-size: 2.6rem;
            font-family: 'Nunito', sans-serif;
            @media (min-width: 2250px){
              font-size: 3.15rem;
            }
            @media (max-width: 1024px) {
              font-size: 2.4rem;
            }
        }
        .description {
            font-family: 'Nunito', sans-serif;
            font-size: 1.3rem;
             @media (min-width: 2250px){
              font-size: 1.85rem;
            }
            @media (max-width: 1024px) {
              font-size: 1.25rem;
            }
        }
    }


</style>
